<template>
    <div class="socials-container">
        <NuxtLink
            to="https://x.com/Chargemap"
            title="X Chargemap"
            external
            target="_blank"
        >
            <IconTwitter />
        </NuxtLink>
        <NuxtLink
            to="https://www.facebook.com/Chargemap"
            title="Facebook Chargemap"
            external
            target="_blank"
        >
            <IconFacebook />
        </NuxtLink>
        <NuxtLink
            to="https://www.instagram.com/chargemap_com/"
            title="Instagram Chargemap"
            external
            target="_blank"
        >
            <IconInstagram />
        </NuxtLink>
        <NuxtLink
            to="https://linkedin.com/company/chargemap/"
            title="LinkedIn Chargemap"
            external
            target="_blank"
        >
            <IconLinkedin />
        </NuxtLink>
        <NuxtLink
            to="https://www.youtube.com/channel/UCxAJ3GC2ALldXBuN04eqT7w"
            title="YouTube Chargemap"
            external
            target="_blank"
        >
            <IconYoutube />
        </NuxtLink>
    </div>
</template>

<style scoped>
.socials-container {
  @apply flex flex-row gap-3 md:gap-2 lg:gap-4 items-center;
}
.socials-container svg {
  @apply text-sky-700 hover:text-sky-500 active:text-sky-700 h-8 w-8 md:w-7 md:h-7;
}
</style>
